module.exports = __webpack_public_path__ + "img/pr-13.e605ef7c.png";